import React from 'react';
import {getUserName, getUserPhoneNumber, getUserType, logout} from "../../helpers/authenticator";
import logo from "../../assets/imgs/zing_white_logo.png";
import {Link} from "react-router-dom";
import general_helper from "../../helpers/general_helper";
import {CourierDropdown, RiderDropdown, UserDropdown} from "./DropdownMenus";

const Header = () => {

    const showDropdownMenu = () => {
        switch (getUserType()) {
            case general_helper.deliveryType.user:
                return <UserDropdown/>;
            case general_helper.deliveryType.rider:
                return <RiderDropdown/>;
            case general_helper.deliveryType.courier:
                return <CourierDropdown/>;
        }
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark mx-auto fixed-top">
            <div className="container">
                <a className="navbar-brand" href="/home">
                    <img src={logo} className="img-fluid logo"/>
                </a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
                        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item">
                            <Link className="nav-link" to="/home" href="#">{getUserName()} - {getUserType()} </Link>
                        </li>
                        <li className="nav-item">
                            <div className="nav-profile-img" id="dropdownMenuButton" data-toggle="dropdown"
                                 aria-haspopup="true"
                                 aria-expanded="false">
                            </div>
                            {showDropdownMenu()}
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default Header;
